import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkbenchLocationService } from '../../shared/workbench-location/service/workbench-location.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'jhi-modal-input',
    templateUrl: './modal-input.component.html',
    styleUrls: ['./modal-input.component.scss']
})
export class ModalInputComponent implements OnInit {

    title: string;
    message: string;
    name: string;

    hasValidationError: boolean;
    validationMessage: string;

    constructor(public modal: NgbActiveModal,
                private workbenchLocationService: WorkbenchLocationService,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
    }

    close() {
        this.modal.dismiss();
    }

    isValidName() {
        if (!this.name || this.name.length === 0) {
            return false;
        }
        return true;
    }

    confirm() {

        this.hasValidationError = false;

        if (!this.isValidName()) {
            this.hasValidationError = true;
            this.validationMessage = this.translateService.instant('field-manager.errors.name.required');
            return;
        }

        this.workbenchLocationService.searchLocations({
            locationNameFilter: {
                type: 'EXACTMATCH',
                value: this.name
            }
        }, null).toPromise().then((response) => {
            if (response && response.body && response.body.length > 0) {
                this.hasValidationError = true;
                this.validationMessage = this.translateService.instant('field-manager.errors.name.already.used');
            } else {
                this.modal.close({ name: this.name });
            }
        });
    }

}
